import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { MultipleSelectorStateActions, } from '../DropdownSelector/MultipleSelectorReducer.js';
import { Tag } from '../Tag/Tag.js';
export function TagSelector({ clearLabel, itemTag, state, dispatch, }) {
    const { items, selectedIds } = state;
    if (selectedIds.length === 0) {
        return null;
    }
    const selectedItems = items.filter(({ id }) => selectedIds.includes(id));
    return (_jsxs(Tag.Group, { children: [selectedItems.map((item) => {
                const { tag, color } = itemTag(item);
                return (_jsxs(Tag, { color: color, children: [tag, _jsx(Tag.Remove, { onClick: () => dispatch(new MultipleSelectorStateActions.ToggleItem(item.id)) })] }, item.id));
            }), _jsx(Tag.Clear, { onClick: () => dispatch(new MultipleSelectorStateActions.ClearSelection()), children: clearLabel })] }));
}
//# sourceMappingURL=TagSelector.js.map